import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CallbackService } from '../services/callback.service';
import { State } from '../services/work.state';

export const callback = (callbackSvc: CallbackService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state?.system?.callback === true) {
        return callbackSvc.callbackModal$().pipe(
          map((modal) => {
            if (modal.result === 'Scheduled') {
              return [
                {
                  ...state,
                  ...{
                    action: {
                      ...state.action,
                      ...{
                        cbDatetime: modal.cbDatetime,
                      },
                    },
                    system: {
                      ...state.system,
                      ...{
                        callback: undefined,
                      },
                    },
                  },
                },
                currentState,
              ] as [Partial<State>, State];
            } else {
              return [
                {
                  ...state,
                  ...{
                    system: {
                      ...state.system,
                      ...{
                        callback: undefined,
                        navToQ: undefined,
                      },
                    },
                  },
                },
                currentState,
              ] as [Partial<State>, State];
            }
          })
        );
      } else if (state?.system?.callback === false) {
        return callbackSvc.cancelCallback$(state.recordId!).pipe(
          map(
            () =>
              [
                {
                  ...state,
                  ...{
                    action: {
                      ...state.action,
                      cbDatetime: undefined,
                    },
                    system: {
                      ...state.system,
                      ...{
                        callback: undefined,
                      },
                    },
                  },
                },
                currentState,
              ] as [Partial<State>, State]
          )
        );
      }
      return of([state, currentState] as [Partial<State>, State]);
    })
  );
